/* eslint-disable no-unused-vars */
import {IWHIJoinPage} from '@nib/join-services-api';

// Do not change the line below for testing. Update the appropriate .env files in /.env folder
// eg GATSBY_JOIN_SERVICES_API_PREFIX=https://join-services-api-[branch-name].kaos.internal.nibit.com.au
const apiBasePath = process.env.GATSBY_JOIN_SERVICES_API_PREFIX;

export const today = new Date();

export const defaultPPCDate = new Date(today.getFullYear(), 2, 1);

export const isNibBrand = (): boolean => Brand === 'nib';

export const MOCK_CURRENT_DATE_COOKIE = 'mock-current-date';

export const isImanBrand = (): boolean => Brand === 'iman';

export const isLocal = process.env.GATSBY_ENVIRONMENT === 'local';

export const isProduction = process.env.GATSBY_ENVIRONMENT === 'production';

export const Brand = process.env.GATSBY_BRAND || 'nib';

export const hspConfigurationUrl = process.env.GATSBY_HSP_CONFIGURATION_URL ?? 'https://api-gateway.nib-cf-test.com/nib-hsp-configuration-api/v1/config?app=iwhiJoinWeb&version=1.0.0&brand=nib';

export const BraintreeClientTokenApiUrl = isLocal ? 'https://api-gateway.nib-cf-test.com/nib-payment-token-api/v1/auth/clientToken' : process.env.GATSBY_BRAINTREE_CLIENT_TOKEN_API_URL;

export const APPS_CONFIG_LAMBDA_URL = isLocal ? 'https://api-gateway.nib-cf-test.com/apps-config-lambda/v1' : process.env.GATSBY_APPS_CONFIG_LAMBDA_URL;

export const PRICING_API_URL = process.env.GATSBY_PRICING_API_URL || 'https://api-gateway.nib.com.au/pricing-api-lambda/v1/international-worker';

export const BraintreeClientTokenApiKey = isLocal ? 'e6f02210-1a8b-41f6-b0d9-00bb2c6ef6e2' : process.env.GATSBY_BRAINTREE_CLIENT_TOKEN_API_KEY;

export const NOT_FOUND_ERROR = '/404';

export const SESSION_COOKIE = 'session';

/** TODO: PCAT Integration/product page disabled */
export const SHOW_PRODUCT_PAGE = false;

//export const SHOW_PRODUCT_PAGE = today > new Date(process.env.GATSBY_PRODUCT_PAGE_START_DATE);

//use in local cookie page only
export const SHOW_SCREENER_PAGE = true;

export const RATE_CODE_COOKIE = 'RateCode';

export const CUSTOM_LINK_DATA_COOKIE = 'CustomLinkData';

export const GROUP_NAME_COOKIE = 'GroupName';

export const COMPANY_LOGO_URL_COOKIE = 'LogoUrl';

export const SPONSOR_AND_EMPLOYER_COOKIE = 'SponsorAndEmployer';

export const CAMPAIGN_CRITERIA_COOKIE = 'CampaignCriteria';

export const PRICING_CALC_COOKIE = 'PricingCalc';

export const COOKIE_VERSION = 1;

export const SessionURLV2 = `${apiBasePath}/v2/session`;

export const SessionURLV1 = `${apiBasePath}/v1/session`;

// currently used by our AutoSaveFormFieldOnChange
export const debounceInterval = 300;

export const whicsStringLengthMax = 80;

export const publicKeyURL = `${apiBasePath}/v1/public-key`;

export const JoinURL = `${apiBasePath}/v1/join`;

export const PreviousFundsUrl = `${apiBasePath}/v1/previous-funds`;

export const ExcessesUrl = `${apiBasePath}/v1/products/filtered`;

export const CampaignUrl = `${apiBasePath}/v3/campaign`;

export const CustomLinkUrl = `${apiBasePath}/v1/custom/iwhi`;

export const LookupUrl = `${apiBasePath}/v1/lookup`;

// Note: this will eventually change and we should be getting this from an environment variable. Will depend on the brand used
export const IMAN_QUOTE_URL = '/join';

// Note: this will eventually change and we should be getting this from an environment variable. Will depend on the brand used
export const NIB_QUOTE_URL = '/overseas-working-visitors/new/join';

// Note: this will eventually change and we should be getting this from an environment variable. Will depend on the brand used
export const IMAN_CONTACT_LINK = '/contact-iman';

// Note: this will eventually change and we should be getting this from an environment variable. Will depend on the brand used
export const NIB_CONTACT_LINK = '/contact-us';

export const KAOS_IMAN_HOMEPAGE = 'https://www.austhealth-cf-test.com';
export const PROD_IMAN_HOMEPAGE = 'https://www.austhealth.com';
export const KAOS_NIB_HOMEPAGE = 'https://www.nib-cf-test.com/overseas-working-visitors';
export const PROD_NIB_HOMEPAGE = 'https://www.nib.com.au/overseas-working-visitors';

export const getQuoteHomepageLink = () => {
  if (isProduction) {
    return Brand === 'iman' ? PROD_IMAN_HOMEPAGE : PROD_NIB_HOMEPAGE;
  } else {
    return Brand === 'iman' ? KAOS_IMAN_HOMEPAGE : KAOS_NIB_HOMEPAGE;
  }
};

export const IWHIPageList: IWHIJoinPage[] = [
  {
    name: 'Welcome',
    title: 'Welcome',
    mobileTitle: 'Welcome',
    link: '/welcome',
    stepOrder: 1
  },
  {
    name: 'HospitalExtras',
    title: 'Cover',
    mobileTitle: 'Cover',
    link: '/',
    stepOrder: 2
  },
  {
    name: 'YourDetails',
    title: 'Details',
    mobileTitle: 'You',
    link: '/your-details',
    stepOrder: 3
  },
  {
    name: 'FamilyDetails',
    title: 'Family',
    mobileTitle: 'Family',
    link: '/family-details',
    stepOrder: 4
  },
  {
    name: 'HealthDetails',
    title: 'Health',
    mobileTitle: 'Health',
    link: '/health-details',
    stepOrder: 5
  },
  {
    name: 'VisaDetails',
    title: 'Visa',
    mobileTitle: 'Visa',
    link: '/visa-details',
    stepOrder: 6
  },
  {
    name: 'PaymentDetails',
    title: 'Pay',
    mobileTitle: 'Pay',
    link: '/payment-details',
    stepOrder: 7
  },
  {
    name: 'Success',
    title: 'Success',
    mobileTitle: 'Success',
    link: '/success',
    stepOrder: 8
  }
];

export enum IWHIPageIndex {
  WELCOME = 0,
  COVER_DETAILS = 1,
  YOUR_DETAILS = 2,
  FAMILY_DETAILS = 3,
  HEALTH_DETAILS = 4,
  VISA_DETAILS = 5,
  PAYMENT_DETAILS = 6,
  SUCCESS = 7
}
